import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-scroll-left",
  "use": "icon-m-scroll-left-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-scroll-left\"><path d=\"M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0m0 2C10.059 2 2 10.059 2 20s8.059 18 18 18 18-8.059 18-18S29.941 2 20 2m-.729 12 1.414 1.414-3.856 3.857h5.15v2h-5.15l3.856 3.857-1.414 1.414L13 20.271zm8.707 5.271v2h-2v-2zm-3 0v2h-2v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol